// extracted by mini-css-extract-plugin
export default {"header":"MessageView_header__Xf2x6","main":"MessageView_main__sWCfG","item":"MessageView_item__TDNgs"};